import React from 'react';
import cn from 'classnames';
import OldLogo from './OldLogo';
import OldMenu from './OldMenu';
import {createUseStyles} from 'react-jss';

export default function OldNavBar() {
  const legacyStyles = createUseStyles(
    {
      navbar: {
        borderColor: '#e7e7e7',
        minWidth: '220px'
      }
    }
  );

  return (
    <div className={cn('border-r-2 pt-8 pr-10', legacyStyles().navbar)}>
      <OldLogo/>
      <OldMenu/>
    </div>
  )
}

